module.exports = __webpack_public_path__ + "media/images/codigo-f6fb1ad69839969bba671cc60230cfff.svg";